import { Button, Form, Popup, ScrollView, TextBox, SelectBox, List, Item } from 'devextreme-react';
import { Label } from 'devextreme-react/bar-gauge';
import { SimpleItem } from 'devextreme-react/form';
import React, { useRef, useEffect } from 'react';
import { InputOnlyNumber } from '../../common';
import { FormatLineNumber, FormatNumber } from '../../common';

const CusEntInfoLineNumberPopup = ({
  onHiding,
  visibleLineNumberPopup,
  lineNumberList,
  textBoxValue,
  onSelectionChangedList,
  onValueChangedTextBox,
  onClickInsert,
  onClickDelete,
  onClickSave,
  notifyMsg,
  calculatePopupSize,
}) => {
  // console.log('CardBillAccountInfoPopup Load');

  const refLineNumber = useRef(null);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  useEffect(() => {

  }, [visibleLineNumberPopup, lineNumberList]);

  return (
    <React.Fragment>
      <Popup
        title="전화번호수정"
        fullScreen={isMobile}
        visible={visibleLineNumberPopup}
        onHiding={onHiding}
        className="popup"
        width="370px"
        height={320}
        {...calculatePopupSize()}
        showCloseButton={true}
      >
        <div className="cusEnt-info-linenumber-popup popup-content">
        <Form labelLocation={'left'}>
            <SimpleItem>
            <List
                className="lineNumber-List"
                width="21rem"
                dataSource={lineNumberList}
                displayExpr={(item) => `${FormatLineNumber(item.LineNumber)}`}
                selectionMode='single'
                selectbyClick={true}
                allowItemDeleting={true}
                itemDeleteMode='static'
                noDataText="전화번호를 입력해주세요"
                // onSelectionChanged={onSelectionChangedList}
            />
            </SimpleItem>
            <SimpleItem>
            <TextBox
                width="21rem"
                readOnly={false}
                stylingMode='outlined'
                value={textBoxValue}
                onInput={(e) =>
                  InputOnlyNumber(e.event, refLineNumber.current)
                }
                onValueChanged={onValueChangedTextBox}
            />
            </SimpleItem>
        </Form>
        </div>
        <div className="cusEnt-info-linenumber-bottom">
        <Button
            stylingMode="contained"
            type="default"
            text="추가"
            onClick={onClickInsert}
        />
        {/* <Button
            stylingMode="contained"
            type="danger"
            text="삭제"
            onClick={onClickDelete}
        /> */}
        <Button
            stylingMode="contained"
            type="success"
            text="저장"
            onClick={onClickSave}
        />
        </div>
        <div className="notify">
            <span className="notify-error"> {notifyMsg} </span>
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CusEntInfoLineNumberPopup);
